export default {
  'inviteRebate.tabDeposit': 'Comisión por depósito',
  'inviteRebate.tabBet': 'Comisión por apuesta',
  'inviteRebate.tabWinLoss': 'Comisión por ganancia/pérdida',

  'inviteRebate.colSettleDate': 'Fecha de liquidación',
  'inviteRebate.colSettleMonth': 'Mes de liquidación',
  'inviteRebate.colInviter': 'Invitador',
  'inviteRebate.colCoin': 'Moneda',
  'inviteRebate.colHitTier': 'Nivel alcanzado',
  'inviteRebate.tierN': 'Nivel {n}',
  'inviteRebate.level1': 'Nivel 1',
  'inviteRebate.level2': 'Nivel 2',
  'inviteRebate.level3': 'Nivel 3',
  'inviteRebate.levelN': 'Nivel {n}',
  'inviteRebate.colDepositBase': 'Base de depósito',
  'inviteRebate.colBetBase': 'Base de apuesta válida',
  'inviteRebate.colWinLossBase': 'Base de ganancia/pérdida neta',
  'inviteRebate.colCashAmount': 'Monto de comisión',
  'inviteRebate.colCashAmountTotal': 'Total',
  'inviteRebate.colCumulativeCash': 'Comisión acumulada',
  'inviteRebate.colExtraAward': 'Recompensa adicional',
  'inviteRebate.colAwardStatus': 'Estado',
  'inviteRebate.awardStatus1': 'Pendiente',
  'inviteRebate.awardStatus2': 'Emitido',
  'inviteRebate.awardStatus3': 'Rechazado',
  'inviteRebate.colUpdateTime': 'Hora de actualización',
  'inviteRebate.colOperation': 'Operación',
  'inviteRebate.colGameType': 'Tipo de establecimiento',
  'inviteRebate.calcDetail': 'Detalle del cálculo',
  'inviteRebate.calcDetailTitle': 'Detalle del cálculo de comisión',
  'inviteRebate.all': 'Todos',
  'inviteRebate.search': 'Buscar',
  'inviteRebate.reset': 'Restablecer',
  'inviteRebate.export': 'Exportar',
  'inviteRebate.exportEmpty': 'No hay datos para exportar',
  'inviteRebate.operationFail': 'Operación fallida',

  'inviteRebate.colFriendAccount': 'Cuenta del amigo',
  'inviteRebate.colLevel': 'Nivel',
  'inviteRebate.colBaseAmount': 'Base',
  'inviteRebate.colRatio': 'Tasa',
  'inviteRebate.colContributedAmount': 'Comisión aportada',
  'inviteRebate.colFriendDetail': 'Detalle de amigos',
  'inviteRebate.ngrFriendDetailHint': 'Solo se muestran amigos con actividad en el período (GGR / bono / canje de puntos ≠ 0); cada fila se redondea por separado, el total puede diferir 0.01 de la comisión del período',
  'inviteRebate.colRemark': 'Observación',
  'inviteRebate.remarkPlaceholder': 'Observación opcional al confirmar/rechazar la emisión (hasta 200 caracteres)',
  'inviteRebate.extraAward': 'Recompensa adicional',
  'inviteRebate.extraPoint': 'Puntos {n}',

  'inviteRebate.actionConfirmIssue': 'Confirmar emisión',
  'inviteRebate.actionReject': 'Rechazar',
  'inviteRebate.confirmIssueTip': '¿Confirmar la emisión de esta comisión? El efectivo se acreditará de inmediato.',
  'inviteRebate.confirmIssueSuccess': 'Emitido correctamente',
  'inviteRebate.rejectIssueTip': '¿Rechazar esta comisión? Ya no se emitirá.',
  'inviteRebate.rejectIssueSuccess': 'Rechazado',
  'inviteRebate.tabNgr': 'Comisión NGR',
  'inviteRebate.colSettlePeriod': 'Período de liquidación',
  'inviteRebate.settlePeriodTip': 'Filtrar por fecha de inicio del período (día 1 / 16 de cada mes)',
  'inviteRebate.colNgrBase': 'Base NGR',
  'inviteRebate.colPeriodCommission': 'Comisión del período',
  'inviteRebate.colCarryIn': 'Arrastre anterior',
  'inviteRebate.carryInFrom': 'de {{period}}',
  'inviteRebate.colPayable': 'A pagar',
  'inviteRebate.awardStatus4': 'Sin pago · Arrastrado',
  'inviteRebate.noPayableNote': 'A pagar ≤ 0, no se paga; el negativo se arrastra al siguiente período',
  'inviteRebate.colFriendGgr': 'GGR propio',
  'inviteRebate.colFriendBonus': 'Bonos recibidos',
  'inviteRebate.colFriendPointExchange': 'Canje de puntos',
};
